import { Form, Input } from 'antd';
import React from 'react';

import type DocumentFolder from 'stores/DocumentFolder';
import { normalizeInputSpace } from 'utils/String';

import { ModalForm, type SubmitCallback } from '../ModalForm';
import { type DocumentFolderClassRef } from './AddDocument.types';

export interface AddDocumentModalProps {
  isVisible?: boolean;
  onClose?: () => void;
  parentDocument: DocumentFolder;
  documentType: DocumentFolderClassRef;
  documentTypeName: string;
}

function AddDocumentModal({
  isVisible,
  onClose,
  parentDocument,
  documentType,
  documentTypeName,
}: AddDocumentModalProps) {
  const handleFormSubmit: SubmitCallback = async (values) => {
    // Membership is inherited from parentDocument via the new folder's
    // getDefaults (applyDynamicFolderDefaults).
    await parentDocument.documents.addFolder(documentType, {
      name: String(values.documentName).trimEnd(),
    });
  };

  return (
    <ModalForm
      formName="AddDocumentModalForm"
      okText="Create"
      onClose={onClose}
      onSubmit={handleFormSubmit}
      open={isVisible}
      title={`New ${documentTypeName}`}
    >
      <Form.Item
        label={`${documentTypeName} name`}
        name="documentName"
        normalize={(v) => normalizeInputSpace(v)}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </ModalForm>
  );
}

export default AddDocumentModal;
